// users

const state = {
	users: [],
	user: {},
	roles: [],
	teams: [],

};

export default state;